(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('view-suggestion', {
            parent: 'app',
            url: '/view-suggestion',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_HSCW']
            },
            views: {
                'content@': {
                    templateUrl: 'app/view-suggestion/view-suggestion.html',
                    controller: 'ViewSuggestionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('view-suggestion');
                    return $translate.refresh();
                }]
            }
        })
        .state('view-suggestion-detail', {
            parent: 'view-suggestion',
            url: '/view-suggestion/{id}',
              data: {
                    authorities: ['ROLE_ADMIN','ROLE_HSCW'],
                    },
            views: {
                'content@': {
                    templateUrl: 'app/view-suggestion/viewSuggestionDetail.html',
                    controller: 'ViewSuggestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('view-suggestion-detail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Suggestion', function($stateParams, Suggestion) {
                    return Suggestion.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }
})();
